export class RejectionType {
  rejectionType: string;
  rejectionTypeId: number;
}
